import React from 'react';
import {getArticlePath} from '../data/creativeArticles';

function CreativeArticleTeaser({ article }) {
  if (!article) {
    return null;
  }

  return (
    <section id="articoli" className="creative-home-section">
      <div className="container">
        <div className="creative-home-grid">
          <div className="creative-home-copy">
            <p className="landing-kicker">Scrittura creativa</p>
            <h2>Dentro la scrittura di Verso Hemelslinn</h2>
            <p className="creative-home-lead">
              Appunti, scelte narrative e riflessioni nate intorno alla costruzione del romanzo.
            </p>
            <div className="creative-home-actions">
              <a className="btn btn-info" href="/articoli">
                Archivio articoli
              </a>
            </div>
          </div>

          <article className="creative-latest-card">
            <a href={getArticlePath(article)} className="creative-latest-image">
              <img
                src={article.cover}
                alt={article.coverAlt}
                style={{objectPosition: article.coverPosition || 'center center'}}
              />
            </a>
            <div className="creative-latest-body">
              <p className="creative-meta">
                {article.date} · {article.readingTime}
              </p>
              <h3>
                <a href={getArticlePath(article)}>{article.title}</a>
              </h3>
              <p>{article.excerpt}</p>
              <a className="creative-text-link" href={getArticlePath(article)}>
                Leggi l’articolo
              </a>
            </div>
          </article>
        </div>
      </div>
    </section>
  );
}

export default CreativeArticleTeaser;
